import {
  ColumnsConfig,
  ColumnLocation,
} from '@bingads-webui-campaign/targeting-settings-scaffolds';

export default class LocationsGridColumnsConfig extends ColumnsConfig {
  constructor({
    scope,
    level,
    parentView,
  }) {
    const selfColumns = [ColumnLocation];

    super({
      selfColumns,
      scope,
      level,
      parentView,
      isExcludeLocation: false,
    });
  }

  getColumnsConfig() {
    return super.getColumnsConfig('locations', undefined, false);
  }
}
